import { render, staticRenderFns } from "./TermsAgrees.vue?vue&type=template&id=064e675f&scoped=true&"
import script from "./TermsAgrees.vue?vue&type=script&lang=js&"
export * from "./TermsAgrees.vue?vue&type=script&lang=js&"
import style0 from "./TermsAgrees.vue?vue&type=style&index=0&id=064e675f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064e675f",
  null
  
)

export default component.exports